/* pantallas-alumno (B): EL RELOJ DEL EXAMEN (piezas nuevas de la parte 1).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Pildora de 36: icono de reloj y el tiempo de 16 px bold con numeros tabulares, fondo #141414, borde
   #262626. Menos de 5 minutos: texto #F27A2E, fondo #1A120C, borde #3A2414. Menos de 1 minuto: texto
   #F87171, fondo #1C1010, borde #4A1F1F. Los cortes (300 y 60 segundos) son los de hoy en
   ExamSimulator. El TEXTO lo da la pantalla con su formateador de siempre (`formatTime`, y "--:--"
   sin dato): esta pieza no cuenta ni formatea.
   Remate (R3): cada cifra del tiempo va en su caja de ancho fijo (`CifrasFijas`): la pildora ya no cambia
   de ancho cuando cambian sus cifras y no se mueve en el centro de la cabecera. */
import React from 'react';
import { Clock } from 'lucide-react';
import CifrasFijas from './CifrasFijas';

export const TONOS_DEL_RELOJ = Object.freeze({
  normal: { fondo: '#141414', borde: '#262626', texto: '#F4F4F3' },
  naranja: { fondo: '#1A120C', borde: '#3A2414', texto: '#F27A2E' },
  rojo: { fondo: '#1C1010', borde: '#4A1F1F', texto: '#F87171' },
});

export function tonoDelReloj(segundos) {
  if (typeof segundos !== 'number' || !Number.isFinite(segundos)) return 'normal';
  if (segundos < 60) return 'rojo';
  if (segundos < 300) return 'naranja';
  return 'normal';
}

export default function Reloj({ segundos, texto, testid, etiqueta, className = '' }) {
  const tono = tonoDelReloj(segundos);
  const c = TONOS_DEL_RELOJ[tono];
  return (
    <span
      role="timer"
      aria-label={etiqueta}
      data-testid={testid}
      data-tono={tono}
      className={`inline-flex items-center gap-1.5 h-9 px-3 rounded-full border shrink-0 ${className}`.trim()}
      style={{ backgroundColor: c.fondo, borderColor: c.borde, color: c.texto }}
    >
      <Clock className="w-4 h-4 shrink-0" aria-hidden="true" />
      <span data-parte="tiempo" className="text-[16px] leading-none font-bold tabular-nums"><CifrasFijas texto={texto} /></span>
    </span>
  );
}
